import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (_, props: { width?: number | string }) => ({
    select: {
      minWidth: props.width ?? 188,
      '.ant-select-selection-item': {
        fontSize: 14
      },
      '.ant-select-selection-placeholder': {
        fontSize: 14
      }
    }
  })
)
